import React, { Component } from "react";
import { Auth } from "aws-amplify";
const AuthContext = React.createContext();

class AuthProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticating: true,
      isAuthenticated: false,
      isAdmin: false,
      jwtToken: null,
      roles: [],
      organization_type: "",
    };
  }

  async componentDidMount() {
    try {
      const jwtToken = await Auth.currentSession();
      this.setState({ jwtToken }, () => {
        let cGroups = jwtToken.idToken.payload["cognito:groups"] || [];
        let isAdmin = cGroups.filter((gr) => gr === "admin").length > 0;
        let organization_type =
          jwtToken.idToken.payload["custom:organization_type"] || "";
        this.setState({
          isAdmin,
          roles: cGroups,
          organization_type: organization_type,
        });
      });
    } catch (e) {
      if (e !== "No current user") {
        alert(e.message);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  userIsAdmin = (status) => {
    this.setState({ isAdmin: status });
  };

  userHasAuthenticated = (authenticated) => {
    this.setState({ isAuthenticated: authenticated });
  };

  setRoles = (roles) => {
    this.setState({ roles: roles });
  };

  clearRoles = () => {
    this.setState({ roles: [] });
  };

  setOrgType = (organization_type) => {
    this.setState({ organization_type: organization_type });
  };

  clearOrgType = () => {
    this.setState({ organization_type: "" });
  };

  render() {
    if (this.state.isAuthenticating) {
      return null;
    }

    return (
      <AuthContext.Provider
        value={{
          isAuthenticated: this.state.isAuthenticated,
          isAdmin: this.state.isAdmin,
          isAuthenticating: this.state.isAuthenticating,
          userHasAuthenticated: this.userHasAuthenticated,
          userIsAdmin: this.userIsAdmin,
          jwtToken: this.state.jwtToken,
          roles: this.state.roles,
          clearRoles: this.clearRoles,
          setRoles: this.setRoles,
          clearOrgType: this.clearOrgType,
          setOrgType: this.setOrgType,
          organization_type: this.state.organization_type,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

const AuthConsumer = AuthContext.Consumer;
export { AuthContext, AuthProvider, AuthConsumer };
